import { Record, Map } from 'immutable';
import User from './user';
import LikeType from './likeType';

const LikeRecord = Record({
  id: undefined,
  user: User,
  likeType: LikeType,
  createdAt: undefined,
  _links: new Map(),
  _forms: new Map()
});

class Like extends LikeRecord {

  constructor(props) {
    props.user = new User(props.user);
    props.likeType = new LikeType(props.likeType);

    super(props);
  }

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default Like;


// WEBPACK FOOTER //
// ./src/api/models/like.js